import $ from 'jquery';

export default function () {
    $('.js-accordion-panel').on('click', '.js-accordion-header', function() {
        $('.js-accordion-body').slideUp().removeClass('flipInX');
        $('.js-accordion-button').removeClass('open');
        if($(this).next().is(':hidden')) {
            $(this).next().slideDown().addClass('flipInX');
            $(this).find('.js-accordion-button').addClass('open');
        } else {
            $(this).next().slideUp();
        }
    });
}
